import {
  Avatar,
  Card,
  CardHeader,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography
} from '@mui/material';
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  koKR,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { getIcon } from 'src/utils/hex-to-rgba';
import { apiService } from '../../api/axiosClient';
import Spinner from '../../components/spinner';
import CustomNoRowsOverlay from '../../utils/CustomNoRowsOverlay';

const TableBooking = props => {
  const {reload, setReload, setBookingID} = props;
  const [loading, setLoading] = useState(true)  
  const [page, setPage] = useState(0)
  const [total, setTotal] = useState(0)
  const [sort, setSort] = useState('desc')
  const [pageSize, setPageSize] = useState(10)
  const [list, setList] = useState([])
  const [sortColumn, setSortColumn] = useState('id')
  const [selected, setSelected] = useState([])

  const loadBooking = 
    async (sort, column) => {
      try {
        const response = await apiService.get('/booking', {
          params: {
            sort,
            column,
            page,
            pageSize
          }
        });
        const payload = response.data;

        setTotal(payload.size);
        setList(payload.list);
        setLoading(false);
      } catch (e) {
        console.error('Error loading booking data:', e);
      }
    }

  useEffect(() => {
    loadBooking(sort, sortColumn)
  }, [page, pageSize, reload])

  const handleSortModel = (newModel) => {
    if (newModel.length) {
      setSort(newModel[0].sort)
      setSortColumn(newModel[0].field)
      loadBooking(newModel[0].sort, newModel[0].field)
    } else {
      setSort('desc')
      setSortColumn('uptime')
    }
  }

  const onPageSizeChange = e => {
    setPageSize(e.target.value)
  }

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const _page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Stack direction="row" spacing={2} sx={{ pr: 4, alignItems: 'center' }}>
        <InputLabel id="pagesize-select">행/페이지</InputLabel>
        <FormControl variant="standard" sx={{ mr: 1, minWidth: 70 }}>
          <Select
            labelId="pagesize-select"
            id="pagesize-select"
            value={pageSize}
            onChange={onPageSizeChange}
            label="pageSize"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          color="primary"
          count={pageCount}
          page={_page + 1}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
      </Stack>
    );
  }

  const columns = [
    {
      flex: 0.2,
      minWidth: 220,
      field: 'sku',
      hideable: false,
      headerName: 'SKU',
      renderCell: params => (
          <a href='#' onClick={() => setBookingID(params.row.id)} >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar alt="image" src={getIcon(params.row.icon)} variant="rounded" />
              <Typography variant='body2' sx={{ ml: 1, color: 'text.primary' }}>
                {params.row.sku}
              </Typography>
            </Stack>
          </a>
      )
    },
    {
      flex: 0.2,
      minWidth: 300,
      field: 'name',
      hideable: false,
      headerName: '이름',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.name}
        </Typography>
      )
    },
    {
      flex: 0.2,
      minWidth: 110,
      field: 'username',
      headerName: '고객이름',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.username}
        </Typography>
      )
    },
    {
      flex: 0.2,
      field: 'intime',
      minWidth: 140,
      headerName: '입고날짜',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.intime || 'TBD'}
        </Typography>
      )
    },
    {
      flex: 0.2,
      field: 'uptime',
      minWidth: 140,
      headerName: '등록날짜',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.uptime.toLocaleString('ko-KR')}
        </Typography>
      )
    }
  ]

  return (
    loading ?
    <Spinner/>
    :
    <Card>
      <CardHeader title='알림요청 내역' />
      <DataGrid
        sx={{
          ...(list.length == 0 && { '& .MuiDataGrid-virtualScrollerContent': {height: '200px !important' } })
        }}
        localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
        autoHeight
        getRowId={row => row.id}
        pagination
        rows={list}
        rowCount={total || 0}
        columns={columns}
        pageSize={pageSize}
        sortingMode='server'
        paginationMode='server'
        onSortModelChange={handleSortModel}
        onPageChange={newPage => setPage(newPage)}
        components={{
          Pagination: CustomPagination,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        componentsProps={{
          toolbar: {
            numSelected: selected.length,
            selected,
            reload,
            setReload
          }
        }}
        checkboxSelection
        disableSelectionOnClick
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRows = list.filter((row) =>
            selectedIDs.has(row.id),
          );

          setSelected(selectedRows)
        }}
        experimentalFeatures={{ newEditingApi: true }}
      />
    </Card>
  )
}

export default TableBooking
